
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/models/sql-editor",
      function () {
        return require("private-next-pages/models/sql-editor.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/models/sql-editor"])
      });
    }
  